// extracted by mini-css-extract-plugin
export var dropdownButton = "_3j-0";
export var fullWidthDropdownButton = "_3j-1";
export var icon = "_3j-3";
export var iconPlaceholder = "_3j-2";
export var menuItemRow = "_3j-9";
export var separator = "_3j-e";
export var shortcutContainer = "_3j-7";
export var shortcutContainerFilled = "_3j-8";
export var shortcutIconLg = "_3j-6";
export var shortcutIconMd = "_3j-5";
export var shortcutIconSm = "_3j-4";
export var submenuChevron = "_3j-d";
export var submenuDropdown = "_3j-a";
export var submenuTriggerRow = "_3j-b";
export var submenuTriggerRowOpen = "_3j-c";